import { lifecycle, withStateHandlers, compose } from 'recompose';
import { withContext } from 'context';

// Fake local storage for pre-load
const localStorageSim = {
  getItem: () => undefined,
  setItem: () => {
    console.error(Error('Tried to set local storage item before local storage was ready'));
  },
  clear: () => {
    console.error(Error('Tried to clear local storage before it had loaded'));
  },
  removeItem: () => {
    console.error(Error('Tried to remove local storage item before local storage was ready'));
  }
};

const localStorageProps = ({ context }) => {
  return {
    localStorage: context && context.localStorage ? context.localStorage : localStorageSim
  };
};

const withLocalStorageState = withStateHandlers(localStorageProps, {
  setLocalStoredValue: props => (key, value) => {
    if (window) {
      if (value === undefined || value === null) {
        props.localStorage.removeItem(key);
      } else {
        props.localStorage.setItem(key, value);
      }
      return { localStorage: props.localStorage };
    }
  },
  removeLocalStoredValue: props => (key, value) => {
    if (window) {
      props.localStorage.removeItem(key, value);
      return { localStorage: props.localStorage };
    }
  },
  bindLocalStorage: state => localStorage => ({
    localStorage
  })
});

const withLocalStorageLoader = lifecycle({
  componentDidMount() {
    this.props.bindLocalStorage(window.localStorage);

    // Create local clone of local storage values with simmed functions
    const storage = {
      ...localStorage,
      ...localStorageSim
    };
    // add getItem function but dont allow setting
    storage.getItem = key => storage[key];

    // store this clone as a speedy-to-load version of local storage in context
    this.props.context.setState(
      {
        localStorage: storage
      },
      () => {
        console.log('Local storage set');
      }
    );
  }
});

export default compose(
  withContext,
  withLocalStorageState,
  withLocalStorageLoader
);
